module.exports = __webpack_public_path__ + "static/media/homepage-video-background.bcdc04d0.mp4";